<template>
  <header class="header" :class="{'header-menu-open': isMobileMenuOpen}">
    <div class="header-container">
      <div class="logo-container">
        <img @click="mobileMenuToggle()" class="mobile-menu-img" :src="require(`../../../public/custom/images/main-page/mobile-menu-${isMobileMenuOpen ? 'close' : 'open'}.svg`)" alt="Mobile menu image">
        <img @click="navigate('main')" class="logo" src="../../../public/custom/images/logo.svg" alt="Logo image">
      </div>
      <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
      <div class="nav-container">
        <nav class="nav-block">
          <router-link class="nav-link" v-for="routeName of routesList" :key="routeName" :to="{ name: routeName }" @click.native="closeMobileMenu()">
            <img class="nav-img" :src="require(`../../../public/custom/images/nav/${routeName}.svg`)" alt="Nav image">
          </router-link>
        </nav>
        <!-- <div class="lang-block">En</div> -->
        <div class="profile-img" @click="navigate('profile')">{{ parsedUserName }}</div>
        <div class="sign-out-block">
          <base-button
            :text="$t('message.header.signOutBtn')"
            @click="signOut()"
            class="desktop-out-btn"
          />
        </div>
      </div>

      <div class="mobile-menu-container" :class="{'mobile-menu-container-open': isMobileMenuOpen}">
        <router-link class="menu-item" v-for="route of mobileMenuRoutesList" :key="route" :to="`/${route}`" @click.native="closeMobileMenu()">
          <img class="menu-item-image" :src="require(`../../../public/custom/images/nav/${route}.svg`)" alt="Menu item image">
          <img class="menu-item-image-checked" :src="require(`../../../public/custom/images/nav/${route}-checked.svg`)" alt="Menu checked item image">
          <span class="mobile-menu-route-name">{{ $t(`message.sideMenu.${route}`) }}</span>
        </router-link>
        <div class="mobile-sign-out-block" v-if="isAuthorized">
          <base-button
            :text="$t('message.header.signOutBtn')"
            @click="signOut()"
            class="mobile-sign-out-btn"
          />
        </div>
      </div>
    </div>
    <div class="bottom-line"></div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Header',
  data() {
    return {
      routesList: window.entityCabinetSettings.avaliableHeaderRotes,
      mobileMenuRoutesList: window.entityCabinetSettings.sideMenuRoutes,
      isMobileMenuOpen: false
    }
  },
  methods: {
    async signOut() {
      await this.$store.dispatch('purgeAuth');
    },
    mobileMenuToggle() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;

      this.$emit('mobileMenuToggle', this.isMobileMenuOpen);
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;

      this.$emit('mobileMenuToggle', this.isMobileMenuOpen);
    },
    navigate(route) {
      this.closeMobileMenu();
      this.$router.push({name: route});
    }
  },
  computed: {
    ...mapGetters(['profile']),
    isAuthorized() {
      return !!this.profile?.role;
    },
    parsedUserName() {
      return this.profile.name_ru?.given_name_ru.slice(0, 1) + this.profile.name_ru?.family_name_ru.slice(0, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    height: 74px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
  }

  .bottom-line {
    @include base-page-container;

    height: 2px;
    border-radius: 3px;
    background-color: var(--base-header-underline-bgc);
  }

  .header-container {
    @include base-page-container;

    height: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .route-name {
    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    color: #121212;
  }

  .nav-container {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .nav-block {
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .nav-link {
    margin-right: 15px;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.09);
    }
  }
  
  .lang-block {
    margin-bottom: 5px;
    margin-right: 25px;
    cursor: pointer;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    user-select: none;
  }

  .sign-out-block {
    width: 101px;
    height: 47px;
  }

  .logo {
    cursor: pointer;
  }

  .logo-container {
    display: none;
  }

  .mobile-menu-img {
    cursor: pointer;
    margin-right: 30px;
  }

  .mobile-menu-container {
    position: fixed;
    height: 100vh;
    width: calc(100vw);
    padding-top: 40px;
    padding-left: 10px;
    box-sizing: border-box;
    top: 74px;
    left: calc(100vw + 700px);
    display: flex;
    flex-direction: column;
    background-color: #F8F8F8;
    transition: left .2s ease-in-out;
    z-index: 10000;
  }

  .mobile-menu-container-open {
    left: 0;
  }

  .profile-img {
    height: 40px;
    width: 40px;
    display: none;
    justify-content: center;
    align-items: center;
    background-color: #F49332;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: white;
    border-radius: 50%;
    cursor: pointer;
  }

  .header-menu-open {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
  }

  .menu-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.02);
    }
    &:hover .menu-item-image {
      display: none;
    }

    &:hover .menu-item-image-checked {
      display: block;
    }
  }

  .router-link-active {
    & .menu-item-image {
      display: none;
    }

    & .menu-item-image-checked {
      display: block;
    }

    .mobile-menu-route-name {
      color: #121212;
      font-weight: 600;
    }
  }

  .menu-item-image,
  .menu-item-image-checked {
    height: 28px;
    width: 28px;
    margin-right: 10px;
    display: block;
  }

  .menu-item-image-checked {
    display: none;
  }

  .mobile-menu-route-name {
    font-size: 16px;
    line-height: 22px;
    color: #878787;
    text-decoration: none;
  }

  .mobile-sign-out-block {
    width: 104px;
    height: 38px;
    margin-top: 20px;
  }

  .mobile-sign-out-btn {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 1155px) {
    .route-name {
      display: none;
    }

    .logo-container {
      display: flex;
    }

    .profile-img {
      display: flex;
    }

    .sign-out-block {
      display: none;
    }

    .nav-block {
      margin-right: 0;
    }
  }
</style>